import { useState } from 'react';
import {
  applyProductChoice,
  productCatalog,
  publicReference,
  readProductChoice,
  productChoiceRecap,
  addCustomerReference,
  readCustomerReferences,
  removeCustomerReference,
} from './product-choice-model';
import { WorkspaceIcon } from './workspace-icons';
export function ProductPicker({
  values,
  onChange,
}: {
  values: Record<string, unknown>;
  onChange: (values: Record<string, unknown>) => boolean;
}) {
  const [search, setSearch] = useState('');
  const choice = readProductChoice(values.summary);
  const group = productCatalog.categories.find((g) => g.id === choice.group);
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  return (
    <section className="product-picker" aria-label="เลือกแนวคิดสินค้า">
      <h3>1. เลือกแนวคิดสินค้า</h3>
      <p className="muted">
        แนวคิดจากเว็บไซต์ SQI Innovation · ภาพประกอบ ไม่ใช่สูตรหรือข้อเสนอที่อนุมัติแล้ว
      </p>
      <div className="product-categories">
        {productCatalog.categories.map((g) => (
          <button
            type="button"
            key={g.id}
            aria-pressed={choice.group === g.id}
            className="product-category"
            onClick={() => {
              setSearch('');
              onChange(
                applyProductChoice(values, { group: g.id, product: '', format: '', packaging: '' }),
              );
            }}
          >
            <img
              src={'/product-ideas/' + g.image}
              alt={'ภาพประกอบ ' + g.label}
              loading="lazy"
              width="220"
              height="132"
            />
            <span>
              <WorkspaceIcon name={g.id} />
              {g.label}
            </span>
          </button>
        ))}
      </div>
      {group ? (
        <div className="idea-fields">
          <label>
            ค้นหาแนวคิด
            <input type="search" value={search} onChange={(e) => setSearch(e.target.value)} />
          </label>
          <label>
            สินค้า
            <select
              value={choice.product}
              onChange={(e) =>
                onChange(applyProductChoice(values, { ...choice, product: e.target.value }))
              }
            >
              <option value="">ยังไม่เลือก</option>
              {group.products
                .filter((p) => p.id === choice.product || p.label.includes(search.trim()))
                .slice(0, 24)
                .map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.label}
                  </option>
                ))}
            </select>
          </label>
          {(['format', 'packaging'] as const).map((key) => (
            <label key={key}>
              {key === 'format' ? 'รูปแบบที่สนใจ' : 'บรรจุภัณฑ์ที่สนใจ'}
              <select
                value={choice[key]}
                onChange={(e) =>
                  onChange(applyProductChoice(values, { ...choice, [key]: e.target.value }))
                }
              >
                <option value="">ยังไม่เลือก</option>
                {(key === 'format' ? group.formats : group.packaging).map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.label}
                  </option>
                ))}
              </select>
            </label>
          ))}
        </div>
      ) : null}
      {group ? (
        <p className="scope" aria-label="แนวคิดที่เลือก">
          {productChoiceRecap(values.summary)} · เสนอไว้เพื่อให้ทีมงานพิจารณา
        </p>
      ) : null}
      <div className="idea-reference">
        <a href={group?.url ?? productCatalog.website} target="_blank" rel="noopener noreferrer">
          ดูแนวคิดบน SQI Innovation
        </a>
        <a href="https://www.merrycosmetic.co.th/" target="_blank" rel="noopener noreferrer">
          ดู Merry Cosmetic เพื่อหาแรงบันดาลใจ
        </a>
      </div>
      {readCustomerReferences(values.summary).map((reference) => (
        <div className="idea-reference" key={reference}>
          <a href={reference} target="_blank" rel="noopener noreferrer">
            {reference}
          </a>
          <button
            type="button"
            className="action secondary"
            onClick={() => onChange(removeCustomerReference(values, reference))}
          >
            ลบลิงก์นี้
          </button>
        </div>
      ))}
      <label>
        ลิงก์สินค้าอ้างอิงสาธารณะ
        <input
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://…"
        />
      </label>
      <button
        type="button"
        className="action secondary"
        onClick={() => {
          if (!url.trim() || !publicReference(url)) {
            setError('ใช้ลิงก์ http หรือ https ที่ไม่มีชื่อผู้ใช้หรือรหัสผ่าน');
            return;
          }
          if (!onChange(addCustomerReference(values, url))) return;
          setUrl('');
          setError('');
        }}
      >
        เพิ่มลิงก์ในแหล่งอ้างอิง
      </button>
      {error ? <p role="alert">{error}</p> : null}
      <p className="scope">
        ใช้เพื่ออธิบายสิ่งที่สนใจ ทีมงานต้องตรวจความเป็นไปได้และสิทธิ์ก่อนใช้ ·
        ไม่ดึงข้อมูลจากลิงก์อัตโนมัติ
      </p>
    </section>
  );
}
